import { UseFormReturn } from 'react-hook-form'

import { IntegratorType, RefBadge } from '../components/ref-badge/RefBadge'
import { StusdsWarning } from '../components/stusds-warning/StusdsWarning'
import { TransactionOverview } from '../components/transaction-overview/TransactionOverview'
import { SavingsDepositTxOverview, StusdsWarningData } from '../types'
import { TokenWithBalance } from '@/domain/common/types'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'

export interface SavingsDepositViewProps {
  underlyingToken: Token
  savingsToken: Token
  selectableAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  txOverview: SavingsDepositTxOverview
  actionsViewState: ActionsViewState
  accountName: string
  stusdsWarningData: StusdsWarningData | undefined
  activeIntegrator: IntegratorType | undefined
}

export function SavingsDepositView({
  underlyingToken,
  savingsToken,
  selectableAssets,
  assetsFields,
  form,
  txOverview,
  actionsViewState,
  accountName,
  stusdsWarningData,
  activeIntegrator,
}: SavingsDepositViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Deposit to {accountName}</DialogTitle>

      <FormAndOverviewWrapper>
        <div className="flex flex-col gap-2">
          <DialogForm form={form} assetsFields={assetsFields} selectorAssets={selectableAssets} />
        </div>
        <TransactionOverview txOverview={txOverview} />
        {activeIntegrator && <RefBadge integrator={activeIntegrator} />}
        {savingsToken.symbol === TokenSymbol('stUSDS') && (
          <StusdsWarning stusdsWarningData={stusdsWarningData} usds={underlyingToken} />
        )}
      </FormAndOverviewWrapper>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
